import { View } from 'react-native';

import {
  IngredientCardContainer,
  IngredientCardImage,
  IngredientCardLabel,
  IngredientCardLabelContainer,
  IngredientCardNoticeLabel,
  IngredientCardPressable,
  IngredientCardQuantity,
  IngredientCardQuantityStepper,
} from './components';

export const IngredientCardV2 = {
  Container: IngredientCardContainer,
  Pressable: IngredientCardPressable,
  Image: IngredientCardImage,
  ImageContainer: View,
  LabelContainer: IngredientCardLabelContainer,
  Label: IngredientCardLabel,
  NoticeLabel: IngredientCardNoticeLabel,
  Quantity: IngredientCardQuantity,
  QuantityStepper: IngredientCardQuantityStepper,
};
